import styled from 'styled-components';
import LinkWithQuery from 'components/LinkWithQuery';
import Nexhealth from 'components/icons/nexhealth';
import { color } from 'theme';
import {
    GREY_400, GREY_300, GREY_900, WHITE,
} from '../../../../constants';

export const AvatarFrame = styled.div`
    position: relative;
`;

export const NexhealthMark = styled(Nexhealth)`
    position: absolute;
    right: -0.25rem;
    bottom: -0.25rem;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 2px solid ${WHITE};
    background: ${WHITE};
    color: ${GREY_900};
`;

export const CellWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${GREY_400};
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.375rem;
    text-transform: capitalize;
`;

export const ActionsCellWrapper = styled(CellWrapper)`
    justify-content: flex-end;
    padding: 0 2rem 0 0;
    gap: 0.5rem;
`;

export const StyledTitleContainer = styled.div`
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.35rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
`;

export const PhoneNumber = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledLink = styled(LinkWithQuery)`
    color: ${color('brand.main')};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
        color: ${color('brand.dark')};
    }
`;
export const EmptyLabel = styled.span`
    font-style: italic;
    color: ${GREY_300};
    font-weight: 300;
    font-size: 0.9375rem;
`;
